import { OverflowMinimumEvent } from '@theme/overflow-list';

/**
 * The header menu's overflow list can report that too few links fit before the
 * header component is listening, which leaves "More" showing where the menu
 * drawer belongs. Replays that state once the header component is ready.
 */
customElements.whenDefined('header-component').then(() => {
  const overflowList = document.querySelector('#header-component overflow-list[minimum-reached]');
  overflowList?.dispatchEvent(new OverflowMinimumEvent(true));
});
